import React from 'react';
import { motion } from 'framer-motion';
export function HumanImpact() {
  return <section className="py-24 bg-white overflow-hidden" data-id="element-150" data-mp="34gffdfponcy2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-151" data-mp="34fx9rsh4rmdh">
        <div className="grid lg:grid-cols-12 gap-12 items-center" data-id="element-152" data-mp="2qq3k57xswy2p">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="lg:col-span-4" data-id="element-153" data-mp="2uq3xep95z386">
            <h2 className="text-brand-gold font-semibold tracking-wider uppercase text-sm mb-3" data-id="element-154" data-mp="2brrrdcdju9gt">
              Our Philosophy
            </h2>
            <h3 className="text-4xl md:text-5xl font-serif text-brand-navy mb-6 leading-tight" data-id="element-155" data-mp="5zkxrrqbeiqt">
              Behind every claim is a person.
            </h3>
            <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-156" data-mp="6scur2a9r97g">
              Workers' compensation isn't just about managing medical bills and
              processing paperwork. It's about helping real people recover from
              unexpected injuries and return to the lives they love.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-157" data-mp="bkmhk9g37t5i">
              At Arissa Cost Solutions, our human-centered approach ensures that
              injured workers receive the right care at the right time,
              providing peace of mind for them and their families while
              delivering measurable results for your bottom line.
            </p>
          </motion.div>

          {/* Bento Grid */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="lg:col-span-8" data-id="element-158" data-mp="3owwo5o16ht2a">
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4 auto-rows-[200px]" data-id="element-159" data-mp="1g9i8bbgw1nib">
              {/* Large Feature Image */}
              <div className="col-span-2 row-span-2 relative rounded-2xl overflow-hidden group" data-id="element-160" data-mp="1laeha3g3jzul">
                <img src="https://images.unsplash.com/photo-1609220136736-443140cffec6?ixlib=rb-4.0.3&auto=format&fit=crop&w=2400&q=90" alt="Older couple smiling together" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-161" data-mp="1q7y1rl3e18uz" />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-navy/80 via-brand-navy/20 to-transparent" data-id="element-162" data-mp="179ljn9ui0on9"></div>
                <div className="absolute bottom-6 left-6 right-6" data-id="element-163" data-mp="9teol6pu7j01">
                  <p className="text-white font-serif text-2xl md:text-3xl font-medium leading-snug" data-id="element-164" data-mp="etarf2mst4e0">
                    ...and a family behind every recovery.
                  </p>
                </div>
              </div>

              {/* Phone Mockup tile */}
              <div className="row-span-2 rounded-2xl overflow-hidden relative group hidden md:flex items-center justify-center bg-gradient-to-br from-brand-navy via-brand-navy to-[#0a1a3a] p-6" data-id="element-165" data-mp="2o30bn1u1e9ps">
                {/* Decorative accents */}
                <div className="absolute -top-10 -right-10 w-40 h-40 bg-brand-gold/15 rounded-full blur-3xl" data-id="element-166" data-mp="294pxx7i9ox11"></div>
                <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-brand-gold/10 rounded-full blur-3xl" data-id="element-167" data-mp="24dzpflejoe24"></div>
                <div className="absolute inset-0 opacity-10" style={{
                backgroundImage: 'radial-gradient(#C9A24B 1px, transparent 1px)',
                backgroundSize: '24px 24px'
              }} data-id="element-168" data-mp="20dfumohg1mj5"></div>

                {/* Phone device built in markup so it always uses the current logo */}
                <div className="relative z-10 h-full max-h-[400px] aspect-[9/18] mx-auto bg-[#05080f] rounded-[2.5rem] p-3 shadow-[0_25px_60px_-15px_rgba(0,0,0,0.7)] ring-1 ring-brand-gold/30 transition-transform duration-700 group-hover:scale-[1.03]" data-id="element-169" data-mp="3lioegd1u625q">
                  {/* Notch */}
                  <div className="absolute top-3 left-1/2 -translate-x-1/2 w-24 h-6 bg-[#05080f] rounded-b-2xl z-20" data-id="element-170" data-mp="3gq4wz5012mvn"></div>
                  {/* Screen */}
                  <div className="relative h-full w-full rounded-[1.9rem] bg-gradient-to-b from-[#102347] to-brand-navy overflow-hidden flex flex-col items-center justify-center px-6 text-center" data-id="element-171" data-mp="32ti1z7rmy6sd">
                    {/* soft screen glow */}
                    <div className="absolute -top-16 left-1/2 -translate-x-1/2 w-40 h-40 bg-brand-gold/10 rounded-full blur-3xl" data-id="element-172" data-mp="2xr9725v7cunm"></div>
                    <div className="relative z-10 flex flex-col items-center w-full" data-id="element-173" data-mp="r2e1edpdfdun">
                      <img src="https://cdn.magicpatterns.com/uploads/9pNo3tTwvFYBri2vFZFThu/Arissa_Cost_Solutions_Logo.png" alt="Arissa Cost Solutions" className="w-full max-w-[140px] object-contain mb-8" data-id="element-174" data-mp="w05sx6m3sxyb" />
                      <div className="w-10 h-px bg-brand-gold/40 mb-5" data-id="element-175" data-mp="2qa49dgqu6z9e"></div>
                      <p className="text-brand-gold font-semibold tracking-[0.2em] uppercase text-[11px] mb-2" data-id="element-176" data-mp="2lgry08b64oyl">
                        Call Today
                      </p>
                      <a href="tel:8552601053" className="font-serif font-bold text-2xl text-white hover:text-brand-gold transition-colors" data-id="element-177" data-mp="2v7wa909glvpq">
                        855.260.1053
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}